import React from 'react';
import { create } from 'jss';
import { ThemeProviderV4, StyledEngineProvider, StylesProviderV4, jssPreset, ThemeProvider } from '~/lib/bn-material-ui';
import { muiTheme, generateClassName } from '~/utility/BinSentry-ui-utility';
import { OpenOrderButton, OpenBinOrdersButton } from '~/common/open-order-button';

export function openOrderButtonParcel(props) {
  const jss = create({
    ...jssPreset(),
    // Define a custom insertion point that JSS will look for when injecting the styles into the DOM.
    insertionPoint: props.insertionPoint,
  });

  return (
    <StyledEngineProvider jss={jss} generateClassName={generateClassName} injectFirst>
      <StylesProviderV4 jss={jss} generateClassName={generateClassName}>
        <ThemeProvider theme={muiTheme}>
          <ThemeProviderV4 theme={muiTheme}>
            <OpenOrderButton
              orderHref={props.orderHref}
              parcel={true}
              insertionPoint={props.insertionPoint}
              style={props.style}
              variant='text'
              size='small'
            >
              {props.title || null}
            </OpenOrderButton>
          </ThemeProviderV4>
        </ThemeProvider>
      </StylesProviderV4>
    </StyledEngineProvider>
  );
}

export function openBinOrdersButtonParcel(props) {
  const jss = create({
    ...jssPreset(),
    // Define a custom insertion point that JSS will look for when injecting the styles into the DOM.
    insertionPoint: props.insertionPoint,
  });

  return (
    <StyledEngineProvider jss={jss} generateClassName={generateClassName} injectFirst>
      <StylesProviderV4 jss={jss} generateClassName={generateClassName}>
        <ThemeProvider theme={muiTheme}>
          <ThemeProviderV4 theme={muiTheme}>
            <OpenBinOrdersButton
              binHref={props.binHref}
              insertionPoint={props.insertionPoint}
              style={props.style}
              variant='outlined'
            >
              {props.title || null}
            </OpenBinOrdersButton>
          </ThemeProviderV4>
        </ThemeProvider>
      </StylesProviderV4>
    </StyledEngineProvider>
  );
}
